import { call, put, takeLatest } from 'redux-saga/effects';

import { InsurancePolicyUserApi } from '@apis/InsurancePolicyUserApi';
import { InsurancePolicyUser } from '@models/InsurancePolicyUser';
import { SagaPayload } from '@utils/typescript';

import { insurancePolicyUserFetch, stateUpdate, StateUpdatePayload, InsurancePolicyUserFetchPayload } from './action';

function* handleInsurancePolicyUserFetch({ payload }: SagaPayload<InsurancePolicyUserFetchPayload>) {
  const state: StateUpdatePayload = { policyUser: null };
  try {
    state.policyUser = (yield call(InsurancePolicyUserApi.get, payload)) as InsurancePolicyUser;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(insurancePolicyUserFetch, handleInsurancePolicyUserFetch);
}
